import { makeStyles } from "@material-ui/core/styles";

export const useCustomDrawerStyles = makeStyles((theme) => ({
  openBtn: {
    color: "#0129FA",
    padding: theme.spacing(1),
  },
  backDrop: {
    backgroundColor: "#00000074",
  },
  customButtonElement: {
    cursor: "pointer",
    // height: "100%",
    display: "flex",
    alightItems: "center",
  },
  disabledButton: {
    opacity: 0.5,
    cursor: "default",
    pointerEvents: "none",
    "&:hover": {
      opacity: 0.5,
    },
  },
  drawerTitle: {
    padding: "40px 24px 24px",
  },
  drawerTitleText: {
    fontSize: 22,
  },
  drawerContent: {
    display: "flex",
    flexDirection: "column",
    padding: 0,
  },
  actionSection: {
    padding: theme.spacing(2, 3),
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    gap: theme.spacing(2),
  },
  actionButtons: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginLeft: "0 !important",
    gap: theme.spacing(1),
  },
  actionButtonsLeft: {
    display: "flex",
    gap: 8,
  },
  drawerSection: {
    padding: "20px 24px",
    borderTop: "1px solid #BEBFC0",
  },
  horizontalBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  verticalBox: {
    display: "flex",
    flexDirection: "column",
  },
}));
